// extracted by mini-css-extract-plugin
module.exports = {"new-search":"new-search-Ee_ac","newSearch":"new-search-Ee_ac","icon":"icon-OI-Cj"};